import React, { useLayoutEffect, useState } from "react";
import DynamicForm from "components/DynamicForm";
import { useNavigate, useParams } from 'react-router-dom';
import {
  Button, Col, Container, DropdownItem, DropdownMenu,
  DropdownToggle, Row, Table, UncontrolledDropdown
} from "reactstrap";
import form from 'formConfigs/addDeliveryRoute';
import Heading from "components/Heading";
import { errorHandler } from "utils/Api";
import { showAlert } from "utils/Alert";
import styles from "./style.module.scss";
import { ThreeDotsVertical } from 'react-bootstrap-icons';
import SearchPackages from "components/OffCanvas/SearchPackagesOffCanvas";
import { getDeliveryRoute, saveDeliveryRoute } from "api/DeliveryRouteApi";
import { getTypeCounterByName } from "api/TypeCounterApi";
import { sequenceGenerator } from "utils/Form";
import { COURIER_ADDRESS_CODE, COURIER_ADDRESS_LABEL, DELIVERY_ROUTE_STATUS_CODES, PACKAGE_NOTIFICATIONS, SEQUENCETYPES } from "utils/Constants";
import { getAddress } from "api/AddressApi";

const AddEditDeliveryRoute = props => {
  const PACKAGE_ON_ROUTE_FILTER = {
    or: [
      { deliveryRouteBoxesId: { attributeExists: false } },
      { deliveryRouteBoxesId: { eq: null } },
    ],
    and: [
      { onRoute: { eq: true } },
    ]
  };

  let navigate = useNavigate();
  let { id: deliveryRouteId } = useParams();
  const [deliveryRouteData, setDeliveryRouteData] = useState({});
  const [packagesList, setPackagesList] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useLayoutEffect(() => {
    if (deliveryRouteId) {
      setIsLoading(true);
      loadDeliveryRouteData(deliveryRouteId);
    } else {
      generateSecuence();
    }
  }, [deliveryRouteId])

  const generateSecuence = async () => {
    const counter = await getTypeCounterByName(SEQUENCETYPES.DELIVERY_ROUTE);
    const sequenceNumber = sequenceGenerator(SEQUENCETYPES.DELIVERY_ROUTE, counter);
    const newFormData = {
      ...deliveryRouteData,
      secuencia: sequenceNumber
    }
    setDeliveryRouteData(newFormData);
  }

  const loadDeliveryRouteData = (deliveryRouteId) => {
    getDeliveryRoute(deliveryRouteId).then((deliveryRouteObject) => {
      setDeliveryRouteData(deliveryRouteObject);
      if (deliveryRouteObject.boxes.items) {
        const packagesOnDeliveryRoute = deliveryRouteObject.boxes.items.reduce((obj, box) => {
          return {
            ...obj,
            [box.id]: box
          };
        }, {});
        setPackagesList(packagesOnDeliveryRoute);
      }
    }).catch((e) => console.log("fetch deliveryRoute data error", e))
      .finally(() => { setIsLoading(false) });;
  }

  const saveData = async (data) => {
    const newPackageList = { ...packagesList };
    if (data.status == DELIVERY_ROUTE_STATUS_CODES.ON_ROUTE) {
      for (var packageId in newPackageList) {
        const packageData = newPackageList[packageId];
        if (!packageData.onRoute) {
          newPackageList[packageId] = {
            ...packageData,
            isDelivered: false,
            onRoute: true,
            notificationNeeded: true,
            notificationType: PACKAGE_NOTIFICATIONS.PACKAGE_ON_ROUTE
          }
        }
      }
    } else if (data.status == DELIVERY_ROUTE_STATUS_CODES.DELIVERIED) {
        for (var packageId in newPackageList) {
          const packageData = newPackageList[packageId];
          if (!packageData.onRoute) {
            newPackageList[packageId] = {
              ...packageData,
              isDelivered: true,
            }
          }
        }
      }

      setIsLoading(true);
      saveDeliveryRoute(data, newPackageList)
        .then(async (r) => {
          showAlert("success", `La ruta de entrega fue ${((data && data.id) ? "actualizado" : "creado")} exitosamente`);
          navigate("/admin/routes");
        }).catch(e => {
          errorHandler(e);
          showAlert("danger", "No fue posible guardar la informacion de la ruta de entrega");
        }).finally((e) => {
          setIsLoading(false);
        });
    };

    const renderPackageList = () => {
      return Object.keys(packagesList).map((boxId) => {
        const box = packagesList[boxId];
        return (
          <tr key={box.id}>
            <td>
              {box.secuencia}
            </td>
            <td>
              {box.client}
            </td>
            <td>
              {box.tracking_num}
            </td>
            <td>
              {box.provedor}
            </td>
            <td>
              {rowActions(box)}
            </td>
          </tr>
        );
      });
    }

    const removeBoxFromDeliveryRoute = (boxid) => {
      if (packagesList[boxid]) {
        let newPackagesList = { ...packagesList }
        delete newPackagesList[boxid];
        setPackagesList(newPackagesList);
      }
    }

    const rowActions = (box) => {
      return (
        <UncontrolledDropdown>
          <DropdownToggle tag="span" className={styles.threedotsBtn} >
            <ThreeDotsVertical size="1.5rem" />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem header>
              Acciones
            </DropdownItem>
            <DropdownItem onClick={(e) => removeBoxFromDeliveryRoute(box.id)}>
              Remover Paquete de Ruta
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      );
    }

    const updateFormState = (formNewData) => {
      setDeliveryRouteData(formNewData);
    }

    return (
      <>
        <Heading yellowBg={true} headingLevel="h2" className="pt-4 pb-4" label="Informacion de Ruta" sticky bordered >
          <Col sm={2}>
            <Row>
              <Col>
                <Button color="danger" onClick={(e) => { navigate("/admin/routes") }}> Cerrar</Button>
              </Col>
              <Col >
                <Button className="float-end" form="addDeliveryRoute" type="submit" color="success"> Guardar</Button>
              </Col>
            </Row>
          </Col>
        </Heading>
        <Container>
          <DynamicForm
            id="addDeliveryRoute"
            externalFormState={deliveryRouteData}
            useExternalState={true}
            onStateChange={updateFormState}
            formConfig={form}
            onSubmit={saveData}
            isLoading={isLoading}>
            <hr />
            <Heading headingLevel="h4" className="pt-2 pb-2" label="Paquetes en Ruta" >
              <Col sm={2}>
                <Row>
                  <Col>
                    <SearchPackages
                      className="float-end"
                      btnColor="primary"
                      searchFilter={PACKAGE_ON_ROUTE_FILTER}
                      currentSelection={packagesList}
                      onSelect={setPackagesList}>
                      Agregar Paquetes
                    </SearchPackages>
                  </Col>
                </Row>
              </Col>
            </Heading>
            <Table hover>
              <thead>
                <tr>
                  <th>
                    #
                  </th>
                  <th>
                    Client
                  </th>
                  <th>
                    Tracking Number
                  </th>
                  <th>
                    Provedor
                  </th>
                  <th width="2%"></th>
                </tr>
              </thead>
              <tbody>
                {renderPackageList()}
              </tbody>
            </Table>
          </DynamicForm>
        </Container>
      </>
    );
  }

  export default AddEditDeliveryRoute;
